<template>
	<JBox>
		<JFlex class="s-pl-2 s-justify-between s-mb-2 s-items-center">
			<!-- Actions on left -->
			<JBox>
				<JButton :variant="activeTool === 'select' ? 'default' : 'white'" class="s-mr-2" @click="setActiveTool('select')">
					<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" class="cursor-click w-6 h-6">
						<path
							fill-rule="evenodd"
							d="M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z"
							clip-rule="evenodd"
						></path>
					</svg>
				</JButton>
				<JButton :variant="activeTool === 'rectangle' ? 'default' : 'white'" class="s-mr-2" @click="setActiveTool('rectangle')">
					<svg
						width="20"
						height="20"
						fill="currentColor"
						version="1.1"
						id="Capa_1"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						viewBox="0 0 512 512"
						style="enable-background:new 0 0 512 512;"
						xml:space="preserve"
					>
						<g>
							<g>
								<path
									d="M497,51H15C6.716,51,0,57.716,0,66v380c0,8.284,6.716,15,15,15h482c8.284,0,15-6.716,15-15V66
			C512,57.716,505.284,51,497,51z"
								/>
							</g>
						</g>
					</svg>
				</JButton>
				<JButton variant="white" class="s-mr-2" @click="resetZoom">
					<svg width="20" height="20" fill="currentColor" x="0px" y="0px" viewBox="0 0 512 512" class="s-text-indigo-500">
						<g>
							<g>
								<path
									d="M492,0H344.212c-11.046,0-20,8.954-20,20s8.954,20,20,20h99.503L283.394,200.322c-7.811,7.811-7.811,20.474,0,28.284
			c7.81,7.81,20.473,7.811,28.284,0L472,68.284v99.503c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V20
			C512,9.115,503.154,0,492,0z"
								/>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M228.606,283.394c-7.811-7.81-20.474-7.811-28.284,0L40,443.716v-99.503c0-11.046-8.954-20-20-20s-20,8.954-20,20V492
			c0,10.866,8.853,20,20,20h147.788c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20H68.284l160.322-160.322
			C236.417,303.867,236.417,291.204,228.606,283.394z"
								/>
							</g>
						</g>
					</svg>
				</JButton>
				<JButton variant="white" class="s-mr-2" @click="zoomIn">
					<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" class="zoom-in w-6 h-6 s-text-indigo-500">
						<path d="M5 8a1 1 0 011-1h1V6a1 1 0 012 0v1h1a1 1 0 110 2H9v1a1 1 0 11-2 0V9H6a1 1 0 01-1-1z"></path>
						<path
							fill-rule="evenodd"
							d="M2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8zm6-4a4 4 0 100 8 4 4 0 000-8z"
							clip-rule="evenodd"
						></path>
					</svg>
				</JButton>
				<JButton variant="white" class="s-mr-2" @click="zoomOut">
					<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" class="zoom-out w-6 h-6 s-text-indigo-500">
						<path
							fill-rule="evenodd"
							d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
							clip-rule="evenodd"
						></path>
						<path fill-rule="evenodd" d="M5 8a1 1 0 011-1h4a1 1 0 110 2H6a1 1 0 01-1-1z" clip-rule="evenodd"></path>
					</svg>
				</JButton>
				<JButton variant="white" class="s-mr-2" @click="prevPage">
					<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" class="arrow-left w-6 h-6 s-text-indigo-500">
						<path
							fill-rule="evenodd"
							d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
							clip-rule="evenodd"
						></path>
					</svg>
				</JButton>
				<JButton variant="white" @click="nextPage">
					<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" class="arrow-right w-6 h-6 s-text-indigo-500">
						<path
							fill-rule="evenodd"
							d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
							clip-rule="evenodd"
						></path>
					</svg>
				</JButton>
			</JBox>
		</JFlex>

		<!-- Canvas -->
		<JBox class="s-relative s-overflow-scroll s-h-screen s-border s-border-gray-300 s-bg-gray-300">
			<!-- Displays the pdf based on pdfDrawingTemplate.fileKey, else if preview is on it will render byte from renderPdfDrawingTemplate -->
			<PdfCanvas
				:fileKey="fileKey"
				:scale="scale"
				:page="page"
				:showPreview="showPreview"
				:previewResult="previewResult"
				:isLoading="isLoading"
				@viewport:updated="setViewport"
				@viewport:errorMessage="$emit('errorMessage', $event)"
				@numberOfPages="setMaxPage"
			/>
			<!-- Canvas on top of the other canvas above which displays the drawing boxes of template -->
			<DrawingCanvas
				v-show="!showPreview"
				class="s-absolute s-top-0 s-left-0"
				:templateId="templateId"
				:activeTool="activeTool"
				:drawings="drawings"
				:height="height"
				:width="width"
				:scale="scale"
				:page="page"
				@drawing:selected="$emit('drawing:selected', $event)"
				@drawing:added="$emit('drawing:added', $event)"
				@drawing:updated="$emit('drawing:updated', $event)"
				@drawing:removed="$emit('drawing:removed')"
				@drawing:error="$emit('drawing:error')"
				@drawing:errorMessage="$emit('errorMessage', $event)"
				@activeTool:set="setActiveTool"
				:isSaving="isSaving"
			/>
		</JBox>
	</JBox>
</template>

<script>
import PdfCanvas from "./PdfCanvas"
import DrawingCanvas from "./DrawingsCanvas"

export default {
	props: {
		templateId: {
			type: String
		},
		fileKey: {
			type: String
		},
		drawings: {
			type: Array
		},
		graphQlVariables: {
			type: String
		},
		isSaving: {
			type: Boolean
		},
		showPreview: {
			type: Boolean
		},
		isLoading: {
			type: Boolean
		},
		previewResult: {
			type: [String, Uint8Array]
		}
	},
	components: {
		PdfCanvas,
		DrawingCanvas
	},

	data() {
		return {
			height: null,
			width: null,
			scale: 1,
			increment: 0.25,
			page: 1,
			maxPages: null,
			activeTool: "select" //select or rectangle
		}
	},

	methods: {
		setViewport(payload) {
			this.height = payload.height
			this.width = payload.width
		},
		resetZoom() {
			this.scale = 1
		},
		zoomIn() {
			this.scale += this.increment
		},
		zoomOut() {
			if (this.scale <= this.increment) return
			this.scale -= this.increment
		},
		prevPage() {
			if (this.page === 1) {
				this.page = 1
			} else this.page--
		},
		nextPage() {
			if (this.page + 1 > this.maxPages) {
				this.page = this.maxPages
			} else this.page++
		},
		setMaxPage(event) {
			this.maxPages = event
		},
		setActiveTool(payload) {
			this.activeTool = payload
		},
		handleKeyDown(event) {
			if (event.ctrlKey && event.key === "ArrowRight") {
				event.preventDefault()
				this.nextPage()
			}
			if (event.ctrlKey && event.key === "ArrowLeft") {
				event.preventDefault()
				this.prevPage()
			}
			if ((event.ctrlKey && event.key === "+") || (event.ctrlKey && event.key === "ArrowUp")) {
				event.preventDefault()
				this.zoomIn()
			}
			if ((event.ctrlKey && event.key === "-") || (event.ctrlKey && event.key === "ArrowDown")) {
				event.preventDefault()
				this.zoomOut()
			}
		}
	},

	mounted() {
		window.addEventListener("keydown", this.handleKeyDown)
	},

	beforeDestroy() {
		window.removeEventListener("keydown", this.handleKeyDown)
	},

	watch: {
		showPreview: {
			handler() {
				if (this.showPreview) this.$emit("drawing:selected", null)
			}
		}
	}
}
</script>
